import ExtraFlyoutTabDrawer from './ExtraFlyoutTabDrawer';

export default ExtraFlyoutTabDrawer;
